import Rotas from "./routes/Rotas";
import './App.css';

function App() {
  return (
    <Rotas />
  );
}

export default App;